import development from "Config/development"
import production from "Config/production"
import all from "Config/all"

var env: string = process.env.NODE_ENV || 'development'

type IObjectKeys = {
  [key: string]: IConfig
}

const envConfig: IObjectKeys = {
  development: development,
  production: production
}

const enviromentConfig = envConfig[env];

const config:IConfig = {
  ...all,
  ...enviromentConfig
}

export default config;

export interface IConfig {
  BASE_API_URL?: string;
  BASE_URL?: any,
  linkSupport?: string;
}